/* global theme, pinCampaignModalStrings */

import {
  modal,
  prizeQuantityFields,
  prizeSelectRemaining,
  pinManagement,
} from '../global.js';

// inherit from theme.QtySelector, but make custom functionality for the changeQty method
export default class PinQtySelector extends theme.QtySelector {
  constructor($el, options) {
    super($el, options);

    this.prizeSelectionsMade = 0;
  }

  initEventListeners() {
    this.$plus.on(
      'click',
      function () {
        var qty = this.validateQty(this.$input.val());
        var inputField = this.$input[0];

        if (qty >= inputField.dataset.max || qty >= inputField.max) {
          // error modal
          modal.updateMessage(
            unescape(pinCampaignModalStrings.strings.noInventory)
          );
          modal.open();
        } else if (
          this.prizeSelectionsMade >= pinManagement.winningPinsArray.length
        ) {
          // error modal
          modal.updateMessage(
            unescape(pinCampaignModalStrings.strings.amountExceeded)
          );
          modal.open();
        } else {
          this.addQty(qty);
        }
      }.bind(this)
    );

    this.$minus.on(
      'click',
      function () {
        var qty = this.validateQty(this.$input.val());

        this.subtractQty(qty);
      }.bind(this)
    );

    this.$input.on(
      'change',
      function () {
        var qty = this.validateQty(this.$input.val());
        var inputField = this.$input[0];

        if (qty > inputField.dataset.max || qty > inputField.max) {
          // error modal
          modal.updateMessage(
            unescape(pinCampaignModalStrings.strings.noInventory)
          );
          modal.open();

          // reset to 0
          this.changeQty(0);
        } else if (
          this.prizeSelectionsMade + qty >
          pinManagement.winningPinsArray.length
        ) {
          // error modal
          modal.updateMessage(
            unescape(pinCampaignModalStrings.strings.amountExceeded)
          );
          modal.open();

          // reset to 0
          this.changeQty(0);
        } else if (qty < 0) {
          // error modal
          modal.updateMessage(
            unescape(pinCampaignModalStrings.strings.negativeNumbers)
          );
          modal.open();

          // reset to 0
          this.changeQty(0);
        } else {
          this.changeQty(qty);
        }
      }.bind(this)
    );
  }

  updatePrizeSelectionsCounter() {
    // reset the count
    this.prizeSelectionsMade = 0;

    for (var i = 0; i < prizeQuantityFields.length; i++) {
      var prizeQuantityField = prizeQuantityFields[i];
      this.prizeSelectionsMade =
        this.prizeSelectionsMade + parseInt(prizeQuantityField.value);
    }
  }

  changeQty(qty) {
    this.$input.val(qty);
    this.updatePrizeSelectionsCounter();

    // TODO: can this be moved into updatePrizeSelectionsCounter? Would we even want to?
    // update visible prize count
    for (var i = 0; i < prizeSelectRemaining.length; i++) {
      prizeSelectRemaining[i].innerHTML =
        pinManagement.winningPinsArray.length - this.prizeSelectionsMade;
    }
  }
}
